<header class="dash-toolbar" style="background-color: #00cec9;">
  <div>
    <h3 style="color: white;display: inline-block;text-transform:capitalize;" id="name"  *ngIf="doctype == 'DOCTOR'">
      <span style="color:#cecbcb;" id="name">Welcome </span>
      <span style="font-size: 40px;color:#d63031" id="name" >|</span> Dr.
      {{ docData?.name }}
    </h3>
    <h3 style="color: white;display: inline-block;text-transform:capitalize;" id="name"  *ngIf="doctype != 'DOCTOR'">
      <span style="color:#cecbcb;" id="name">Welcome </span>
      <span style="font-size: 40px;color:#d63031" id="name" >|</span>
      {{ docData?.name }}
    </h3>
    
  </div>
  <div class="tools">
    <div class="dropdown tools-item">
      <a
        class=""
        id="dropdownMenu1"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        <i class="fa fa-bell" style="color:white;margin-top: 15px"></i>
        <i class="tools-item-count" *ngIf="count > 0">{{ count }}</i>
      </a>

      <div
        class="dropdown-menu dropdown-menu-right"
        aria-labelledby="dropdownMenu1"
        *ngIf="appData.length > 0"
      >
        <a
          class="dropdown-item d-flex align-items-center"
          *ngFor="let app of appData"
          (click)="onClickNoti()"
        >
          <div>
            <div class="small text-gray-500">{{ app.date }}</div>
            AppointmentNumber {{ app.number }} is booked
          </div>
        </a>
      </div>
    </div>
    <i class="usr" *ngIf="!this.profileImage"></i>

    <div class="dropdown">
      <button
        class="btn btn-secondary dropdown-toggle"
        type="button"
        style="background-color: transparent;border: 0px transparent;"
        id="dropdownMenuButton"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        <img [src]="this.profileImage" class="doctorProfile" />
      </button>
      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
        <a class="dropdown-item" routerLink="/pas/profile" *ngIf="doctype == 'DOCTOR'">
          <i class="fa fa-file-image-o"></i> Upload Profile
        </a>
        <a (click)="onClickLogout()" class="dropdown-item">
          <i class="fa fa-sign-out"></i> Logout
        </a>
      </div>
    </div>
  </div>
</header>
